import { useFormikContext } from 'formik';
import React from 'react';
import { SelectFieldTW } from 'tailwindComponents/selectTW/SelectFieldTW';
import { IDetailsFormData } from '../types/IDetailsFormData';
import { SelectOption } from 'tailwindComponents/selectTW/interfaces';

const DSS_TIME_OPTIONS: SelectOption[] = [
  { label: '08:00 AM', value: '08:00:00' },
  { label: '08:30 AM', value: '08:30:00' },
  { label: '09:00 AM', value: '09:00:00' },
  { label: '09:30 AM', value: '09:30:00' },
  { label: '10:00 AM', value: '10:00:00' },
  { label: '10:30 AM', value: '10:30:00' },
  { label: '11:00 AM', value: '11:00:00' },
  { label: '11:30 AM', value: '11:30:00' },
  { label: '12:00 PM', value: '12:00:00' },
  { label: '12:30 PM', value: '12:30:00' },
  { label: '01:00 PM', value: '13:00:00' },
  { label: '01:30 PM', value: '13:30:00' },
  { label: '02:00 PM', value: '14:00:00' },
  { label: '02:30 PM', value: '14:30:00' },
  { label: '03:00 PM', value: '15:00:00' },
  { label: '03:30 PM', value: '15:30:00' },
  { label: '04:00 PM', value: '16:00:00' },
  { label: '04:30 PM', value: '16:30:00' },
  { label: '05:00 PM', value: '17:00:00' },
  { label: '05:30 PM', value: '17:30:00' },
  { label: '06:00 PM', value: '18:00:00' },
  { label: '06:30 PM', value: '18:30:00' },
  { label: '07:00 PM', value: '19:00:00' },
];

export const TimeRangeSection: React.FC = () => {
  const { values } = useFormikContext<IDetailsFormData>();

  return (
    <section className="flex flex-col gap-4">
      <SelectFieldTW
        className="w-36"
        name="dssStartTime"
        options={DSS_TIME_OPTIONS.slice(0, -2)}
        labelText="Start Time"
        placeholder="08:00 AM"
        isRequired={values.signerSelectsFromRange}
      />
      <SelectFieldTW
        className="w-36"
        name="dssEndTime"
        options={DSS_TIME_OPTIONS}
        labelText="End Time"
        placeholder="03:00 PM"
        isRequired={values.signerSelectsFromRange}
      />
    </section>
  );
};
